import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectLocationPage } from './select-location.page';

const routes: Routes = [
  {
    path: '',
    component: SelectLocationPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectLocationPageRoutingModule {}
